export const PARAM_KEY_TO__FILTER = {
  has_foil: 'foil',
  has_custom_photo: 'customphoto',
  has_no_custom_photo: 'nocustomphoto',
  has_magnet: 'magnet',
  is_landscape: 'landscape',
  is_portrait: 'portrait',
  is_vow_renewal: 'elopementandvowrenewal',
  featured_artist: 'featuredArtist',
  is_letterpress: 'is_letterpress',
  single_sample_available: 'multisampleenabled',
};

export const SORT_OPTIONS = [
  { value: 'featured', label: 'Featured' },
  { value: 'launch_date', label: 'Recently Added' },
  { value: 'popularity', label: 'Most Popular' },
];

export const SORT_DEFAULT = SORT_OPTIONS[0].value;

const hostname = typeof window === 'undefined' ? process.env.HOSTNAME : window.location.hostname;

const INVITATION_LINK = `https://${hostname}/wedding-planning/invitations/shop`;
const STD_LINK = `https://${hostname}/wedding-planning/save-the-date/shop`;

export const THEMED_METADATA = {
  INVITATION: {
    summer: {
      title_tag: '50+ Summer Wedding Invitation Designs - Zola',
      meta:
        "Zola's summer wedding invitation designs are a warm, fun way to invite cherished ones to your celebration. Enjoy free shipping, guest addressing and envelopes!",
      keywords: 'Summer Wedding Invitations',
      canonical: `${INVITATION_LINK}/summer`,
    },
    fall: {
      title_tag: '120+ Fall Wedding Invitation Designs - Zola',
      meta:
        "Zola's fall wedding invitation designs are a comfy, loving way to invite cherished ones to your celebration. Enjoy free shipping, guest addressing and more!",
      keywords: 'Fall Wedding Invitations',
      canonical: `${INVITATION_LINK}/fall`,
    },
    winter: {
      title_tag: '20+ Winter Wedding Invitation Designs - Zola',
      meta:
        "Zola's winter wedding invitation designs are a sparkling, wintry way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'Winter Wedding Invitations',
      canonical: `${INVITATION_LINK}/winter`,
    },
    spring: {
      title_tag: '40+ Spring Wedding Invitation Designs - Zola',
      meta:
        "Zola's spring wedding invitation designs are a cheerful, lively way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'Spring Wedding Invitations',
      canonical: `${INVITATION_LINK}/spring`,
    },
    elegant: {
      title_tag: '140+ Elegant Wedding Invitation Designs - Zola',
      meta:
        "Zola's elegant wedding invitation designs are a graceful, formal way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords:
        'elegant wedding invitations,fancy wedding invitations,formal elegant wedding invitations,elegant luxury wedding invitations',
      canonical: `${INVITATION_LINK}/elegant`,
    },
    classic: {
      title_tag: '150+ Traditional & Classic Wedding Invitation Designs - Zola',
      meta:
        "Zola's classic wedding invitation designs are a timeless, traditional way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords:
        'traditional wedding invitations,classic wedding invitations,classy wedding invitations,classic formal wedding invitations,classic wedding invitation ideas',
      canonical: `${INVITATION_LINK}/classic`,
    },
    floral: {
      title_tag: '150+ Floral Wedding Invitation Designs - Zola',
      meta:
        "Zola's floral wedding invitation designs are a vibrant, stylish way to invite cherished ones to your celebration. Get free shipping, guest addressing and more!",
      keywords:
        'floral wedding invitations,flower wedding invitation,floral wedding invitation template,floral themed wedding invitations',
      canonical: `${INVITATION_LINK}/floral`,
    },
    greenery: {
      title_tag: '130+ Greenery & Botanical Wedding Invitation Designs - Zola',
      meta:
        "Zola's greenery wedding invitation designs are a bright, leafy way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords:
        'greenery wedding invitations,eucalyptus wedding invitations,botanical wedding invitations,nature wedding invitations,wedding invitations with greenery',
      canonical: `${INVITATION_LINK}/greenery`,
    },
    rustic: {
      title_tag: '80+ Rustic & Country Wedding Invitation Designs - Zola',
      meta:
        "Zola's rustic and country wedding invitation designs are the perfect way to invite cherished ones to your celebration. Enjoy free shipping and envelopes!",
      keywords:
        'rustic wedding invitations,country wedding invitations,rustic wedding invitations cheap,rustic country wedding invitations,rustic chic wedding invitations,rustic theme wedding invitation',
      canonical: `${INVITATION_LINK}/rustic`,
    },
    destination: {
      title_tag: '50+ Destination & Travel Wedding Invitation Designs - Zola',
      meta:
        "Zola's destination wedding invitation designs are a travel-themed way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords:
        'destination wedding invitations,travel themed wedding invitations,travel wedding invitations,destination themed wedding invitations',
      canonical: `${INVITATION_LINK}/destination`,
    },
    beach: {
      title_tag: '20+ Beach Wedding Invitation Designs - Zola',
      meta:
        "Zola's beach wedding invitation designs are a scenic, tropical way to invite cherished ones to your celebration. Shop now with free shipping and addressing!",
      keywords:
        'beach wedding invitations,beach themed wedding invitations,tropical wedding invitations,beach wedding invitations with rsvp cards,ocean themed wedding invitations',
      canonical: `${INVITATION_LINK}/beach`,
    },
    bohemian: {
      title_tag: '50+ Bohemian Wedding Invitation Designs - Zola',
      meta:
        "Zola's boho wedding invitation designs are an earthy, romantic way to invite cherished ones to your celebration. Get free shipping, guest addressing, and more!",
      keywords:
        'boho wedding invitations,bohemian wedding invitations,boho chic wedding invitations',
      canonical: `${INVITATION_LINK}/bohemian`,
    },
    simple: {
      title_tag: '190+ Simple & Minimalist Wedding Invitation Designs - Zola',
      meta:
        "Zola's simple wedding invitation designs are a modern, minimalist way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords:
        'simple wedding invitations,minimalist wedding invitations,simple elegant wedding invitations,basic wedding invitations',
      canonical: `${INVITATION_LINK}/simple`,
    },
    modern: {
      title_tag: '180+ Modern & Contemporary Wedding Invitation Designs - Zola',
      meta:
        "Zola's modern and contemporary wedding invitation designs are the perfect way to invite cherished ones to your celebration. Enjoy free shipping and envelopes!",
      keywords:
        'modern wedding invitations,contemporary wedding invitations,modern unique wedding invitations',
      canonical: `${INVITATION_LINK}/modern`,
    },
    vintage: {
      title_tag: '110+ Vintage Wedding Invitation Designs - Zola',
      meta:
        "Zola's vintage wedding invitation designs are an enduring, antique way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'Vintage Wedding Invitations',
      canonical: `${INVITATION_LINK}/vintage`,
    },
    formal: {
      title_tag: '60+ Formal Wedding Invitation Designs - Zola',
      meta:
        "Zola's formal wedding invitation designs are a traditional, refined way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'Formal Wedding Invite',
      canonical: `${INVITATION_LINK}/formal`,
    },
    funny: {
      title_tag: 'Funny Wedding Invitation Designs - Zola',
      meta:
        "Zola's funny wedding invitation designs are a witty, entertaining way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'Funny Wedding Invitations',
      canonical: `${INVITATION_LINK}/funny`,
    },
    watercolor: {
      title_tag: '80+ Watercolor Wedding Invitation Designs - Zola',
      meta:
        "Zola's watercolor wedding invitation designs are a beautiful, artistic way to invite cherished ones to your celebration. Enjoy free shipping and addressing!",
      keywords: 'Watercolor Wedding Invitations',
      canonical: `${INVITATION_LINK}/watercolor`,
    },
    black: {
      title_tag: '240+ Black Wedding Invitation Designs - Zola',
      meta:
        "Zola's black wedding invitation designs are an elegant, bold way to invite cherished ones to your celebration. Plus get free shipping, envelopes, and more!",
      keywords:
        'black wedding invitations, black background wedding invitations, black vintage wedding invitations',
      canonical: `${INVITATION_LINK}/black`,
    },
    blue: {
      title_tag: '490+ Blue Wedding Invitation Designs - Zola',
      meta:
        "Zola's blue wedding invitation designs are a timeless, modern way to invite cherished ones to your celebration. Enjoy free shipping, addressing and envelopes!",
      keywords:
        'blue wedding invitation, Light blue wedding invitations, Tiffany blue wedding invitations',
      canonical: `${INVITATION_LINK}/blue`,
    },
    burgundy: {
      title_tag: '50+ Burgundy Wedding Invitation Designs - Zola',
      meta:
        "Zola's burgundy wedding invitation designs are a deep, rich way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'burgundy wedding invitations, burgundy wedding invitation templates',
      canonical: `${INVITATION_LINK}/burgundy`,
    },
    coral: {
      title_tag: '25+ Coral Wedding Invitation Designs - Zola',
      meta:
        "Zola's coral wedding invitation designs are a fresh, invigorating way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'coral wedding invitations, coral color wedding invitations',
      canonical: `${INVITATION_LINK}/coral`,
    },
    dusty_blue: {
      title_tag: '40+ Dusty Blue Wedding Invitation Designs - Zola',
      meta:
        "Zola's dusty blue wedding invitation designs are the perfect way to invite cherished ones to your celebration. Enjoy free shipping, addressing and envelopes!",
      keywords: 'dusty blue wedding invitations, Dusty blue wedding invitation sets',
      canonical: `${INVITATION_LINK}/dusty_blue`,
    },
    emerald_green: {
      title_tag: '30+ Emerald Green Wedding Invitation Designs - Zola',
      meta:
        "Zola's emerald green wedding invitations are a rich, inspired way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'emerald green wedding invitation',
      canonical: `${INVITATION_LINK}/emerald_green`,
    },
    gold: {
      title_tag: 'Gold Wedding Invitation Designs - Zola',
      meta:
        "Zola's gold wedding invitation designs are a prestigious way to invite cherished ones to your celebration. Enjoy free shipping, envelopes and guest addressing!",
      keywords: 'gold wedding invitation, gold foil wedding invitations',
      canonical: `${INVITATION_LINK}/gold`,
    },
    green: {
      title_tag: '400+ Green Wedding Invitation Designs - Zola',
      meta:
        "Zola's green wedding invitation designs are an earthy, modern way to invite cherished ones to your celebration. Enjoy free shipping, guest addressing and more!",
      keywords: 'green wedding invitation',
      canonical: `${INVITATION_LINK}/green`,
    },
    lavender: {
      title_tag: '25+ Lavender Wedding Invitation Designs - Zola',
      meta:
        "Zola's lavendar wedding invitation designs are a beautiful, calming way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords:
        'lavender wedding invitations, Light purple wedding invitation, lavender flower wedding invitation',
      canonical: `${INVITATION_LINK}/lavender`,
    },
    navy: {
      title_tag: '150+ Navy Blue Wedding Invitation Designs - Zola',
      meta:
        "Zola's navy blue wedding invitation designs are a bold, loving way to invite cherished ones to your celebration. Enjoy free shipping, guest addressing and more!",
      keywords: 'navy blue wedding invitations, navy blue wedding invitation envelopes',
      canonical: `${INVITATION_LINK}/navy`,
    },
    pink: {
      title_tag: '280+ Pink Wedding Invitation Designs - Zola',
      meta:
        "Zola's pink wedding invitation designs are a fun, charming way to invite cherished ones to your celebration. Enjoy free shipping, addressing and envelopes!",
      keywords:
        'pink wedding invitation, dusty pink wedding invitations, pink silver wedding invitations',
      canonical: `${INVITATION_LINK}/pink`,
    },
    plum: {
      title_tag: '60+ Plum Wedding Invitation Designs - Zola',
      meta:
        "Zola's plum wedding invitation designs are a warm, luxurious way to invite cherished ones to your celebration. Enjoy free shipping, addressing and envelopes!",
      keywords: 'plum wedding invitations, plum colored wedding invitations',
      canonical: `${INVITATION_LINK}/plum`,
    },
    purple: {
      title_tag: '180+ Purple Wedding Invitation Designs - Zola',
      meta:
        "Zola's purple wedding invitation designs are a lush, luxurious way to invite cherished ones to your celebration. Enjoy free shipping, addressing and envelopes!",
      keywords: 'purple wedding invitations, deep purple wedding invitations',
      canonical: `${INVITATION_LINK}/purple`,
    },
    red: {
      title_tag: '140+ Red Wedding Invitation Designs - Zola',
      meta:
        "Zola's red wedding invitation designs are a beautiful, bold way to invite cherished ones to your celebration. Enjoy free shipping, envelopes, and more!",
      keywords:
        'red wedding invitation, elegant red wedding invitations, red themed wedding invitations',
      canonical: `${INVITATION_LINK}/red`,
    },
    rose_gold: {
      title_tag: 'Rose Gold Wedding Invitation Designs - Zola',
      meta:
        "Zola's rose gold wedding invitation designs are a luxe, modern way to invite cherished ones to your celebration. Enjoy free shipping, envelopes and addressing!",
      keywords:
        'rose gold wedding invitations, rose gold foil wedding invitations, elegant rose gold wedding invitations, rose gold geometric wedding invitations',
      canonical: `${INVITATION_LINK}/rose_gold`,
    },
    royal_blue: {
      title_tag: '15+ Royal Blue Wedding Invitation Designs - Zola',
      meta:
        "Zola's royal blue wedding invitation designs are a classic, timeless way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'Royal blue wedding invitation, Royal blue wedding invitation kits',
      canonical: `${INVITATION_LINK}/royal_blue`,
    },
    silver: {
      title_tag: 'Silver Wedding Invitation Designs - Zola',
      meta:
        "Zola's silver wedding invitation designs are a sleek, modern way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'silver wedding invitation, silver wedding invitation cards',
      canonical: `${INVITATION_LINK}/silver`,
    },
    teal: {
      title_tag: '60+ Teal Wedding Invitation Designs - Zola',
      meta:
        "Zola's teal wedding invitation designs are a deep, calming way to invite cherished ones to your celebration. Shop now with free shipping, envelopes and more!",
      keywords:
        'teal wedding invitations, rustic teal wedding invitations, dark teal wedding invitations',
      canonical: `${INVITATION_LINK}/teal`,
    },
    white: {
      title_tag: '190+ White Wedding Invitation Designs - Zola',
      meta:
        "Zola's white wedding invitation designs are the perfect, in style way to invite cherished ones to your celebration. Enjoy free shipping and guest addressing!",
      keywords: 'white wedding invitations, pearl white wedding invitations',
      canonical: `${INVITATION_LINK}/white`,
    },
  },
  SAVE_THE_DATE: {
    summer: {
      title_tag: 'Summer Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's summer save the dates. Bright templates perfect for any celebration. Free shipping, guest addressing and envelopes!",
      keywords: 'summer invitation templates, summer save the dates, summer wedding save the dates',
      canonical: `${STD_LINK}/summer`,
    },
    fall: {
      title_tag: 'Fall Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's fall save the dates. Cozy, crisp templates perfect for any celebration. Get free shipping, guest addressing and more!",
      keywords:
        'fall save the dates, fall wedding save the dates, fall themed save the dates, autumn save the dates, fall invitation ideas',
      canonical: `${STD_LINK}/fall`,
    },
    winter: {
      title_tag: 'Winter Wedding Save the Date Card Templates - Zola',
      meta:
        "Zola's winter wedding invitation designs are a distinguished, seasonal way to invite cherished ones to your celebration. Shop now with free shipping!",
      keywords:
        'winter save the dates, winter wedding save the dates, winter wonderland save the dates, winter themed save the dates',
      canonical: `${STD_LINK}/winter`,
    },
    spring: {
      title_tag: 'Spring Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's spring save the dates. Spring-inspired templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords:
        'spring save the dates, spring wedding save the dates, spring wedding invitation ideas, spring invitation ideas',
      canonical: `${STD_LINK}/spring`,
    },
    elegant: {
      title_tag: 'Elegant Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's elegant save the dates. Refined templates perfect for any celebration. Get free shipping, guest addressing and more!",
      keywords: 'elegant save the dates, elegant wedding save the dates',
      canonical: `${STD_LINK}/elegant`,
    },
    classic: {
      title_tag: 'Classic & Traditional Wedding Save the Date Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's classic and traditional save the date templates perfect for any celebration. Get free shipping, addressing and more!",
      keywords:
        'classic save the dates, traditional save the dates, traditional wedding save the dates, classic wedding save the dates',
      canonical: `${STD_LINK}/classic`,
    },
    floral: {
      title_tag: 'Floral Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's floral save the dates. Decorative flower templates perfect for any celebration. Get free shipping and addressing!",
      keywords: 'floral save the dates, floral save the date cards',
      canonical: `${STD_LINK}/floral`,
    },
    greenery: {
      title_tag: 'Greenery Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's greenery save the dates. Eucalyptus and botanical templates perfect for any celebration. Free shipping and addressing!",
      keywords:
        'eucalyptus save the dates, greenery save the dates, botanical save the dates, nature save the dates, greenery wedding save the dates',
      canonical: `${STD_LINK}/greenery`,
    },
    rustic: {
      title_tag: 'Rustic & Country Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's rustic save the dates. Countryside templates perfect for any celebration. Free shipping, addressing and envelopes!",
      keywords:
        'rustic save the dates, rustic wedding save the dates, country save the dates, rustic theme invitation, rustic country save the dates, rustic chic save the dates',
      canonical: `${STD_LINK}/rustic`,
    },
    destination: {
      title_tag: 'Destination Wedding & Travel Save the Date Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's destination save the dates. Travel-themed templates perfect for any celebration. Get free shipping and addressing!",
      keywords:
        'destination wedding save the dates, destination save the dates, travel themed save the dates, travel save the dates',
      canonical: `${STD_LINK}/destination`,
    },
    beach: {
      title_tag: 'Beach Themed Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's beach save the dates. Oceanside templates perfect for any celebration. Free shipping, guest addressing and envelopes!",
      keywords:
        'beach save the dates, beach themed save the dates, beach wedding save the dates, tropical save the dates, ocean themed save the dates',
      canonical: `${STD_LINK}/beach`,
    },
    bohemian: {
      title_tag: 'Boho Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's boho save the dates. Soft, romantic templates perfect for any celebration. Get free shipping, guest addressing and more!",
      keywords: 'boho save the dates, bohemian save the dates',
      canonical: `${STD_LINK}/bohemian`,
    },
    simple: {
      title_tag: 'Simple & Minimalist Wedding Save the Date Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's simple save the dates. Minimalistic templates perfect for any celebration. Get free shipping, envelopes and more!",
      keywords:
        'simple save the dates, minimalist save the dates, simple wedding save the dates, basic save the dates, simple elegant save the dates',
      canonical: `${STD_LINK}/simple`,
    },
    modern: {
      title_tag: 'Modern Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's modern save the dates. Contemporary templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'modern save the dates, contemporary save the dates, modern wedding save the dates',
      canonical: `${STD_LINK}/modern`,
    },
    vintage: {
      title_tag: 'Vintage & Retro Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's vintage save the dates. Nostalgic templates perfect for any celebration. Get free shipping, envelopes and addressing!",
      keywords:
        'vintage save the dates, retro save the dates, rustic vintage save the dates, vintage style save the dates, vintage wedding save the dates',
      canonical: `${STD_LINK}/vintage`,
    },
    formal: {
      title_tag: 'Formal & Classy Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's formal and classy save the date templates perfect for any celebration. Get free shipping, guest addressing and more!",
      keywords: 'formal save the dates, classy save the dates, fancy save the dates',
      canonical: `${STD_LINK}/formal`,
    },
    funny: {
      title_tag: 'Funny Wedding Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's funny save the dates. Lighthearted, humurous templates perfect for any celebration. Get free shipping and envelopes!",
      keywords:
        'funny save the dates, funny wedding save the dates, humorous save the dates, witty save the dates',
      canonical: `${STD_LINK}/funny`,
    },
    watercolor: {
      title_tag: 'Watercolor Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's watercolor save the dates. Artistic templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'watercolor save the dates',
      canonical: `${STD_LINK}/watercolor`,
    },
    dusty_blue: {
      title_tag: 'Dusty Blue Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's dusty blue save the dates. Cool, refined templates perfect for any celebration. Get free shipping and addressing!",
      keywords: 'dusty blue save the dates, dusty blue save the date cards',
      canonical: `${STD_LINK}/dusty_blue`,
    },
    royal_blue: {
      title_tag: 'Royal Blue Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's royal blue save the dates. Classic templates perfect for any celebration. Get free shipping, addressing and envelopes!",
      keywords: 'royal blue save the date, royal blue save the date cards',
      canonical: `${STD_LINK}/royal_blue`,
    },
    navy: {
      title_tag: 'Navy Blue Save the Date Card Teamplates - Zola',
      meta:
        "Set the tone for your big day with Zola's navy blue save the dates. Timeless templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'navy blue save the date, navy save the date, navy save the date cards',
      canonical: `${STD_LINK}/navy`,
    },
    burgundy: {
      title_tag: 'Burgundy Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's burgundy save the dates. Rich, berry hue templates perfect for any celebration. Free shipping and guest addressing!",
      keywords: 'burgundy save the date, burgundy save the date cards',
      canonical: `${STD_LINK}/burgundy`,
    },
    lavender: {
      title_tag: 'Lavender Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's lavendar save the dates. Tranquil, loving templates perfect for any celebration. Free shipping and guest addressing!",
      keywords: 'lavender save the date, lavender save the date cards',
      canonical: `${STD_LINK}/lavender`,
    },
    plum: {
      title_tag: 'Plum Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's plum save the dates. Regal, elegant templates perfect for any celebration. Get free shipping, addressing and more!",
      keywords: 'plum save the date',
      canonical: `${STD_LINK}/plum`,
    },
    rose_gold: {
      title_tag: 'Rose Gold Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's rose gold save the dates. Exquisite, upscale templates perfect for any celebration. Get free shipping and envelopes!",
      keywords:
        'rose gold save the date, rose gold save the date cards, rose gold wedding save the date, rose save the date, rose save the date cards',
      canonical: `${STD_LINK}/rose_gold`,
    },
    dusty_rose: {
      title_tag: 'Dusty Rose Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's dusty rose save the dates. Modern, romantic templates perfect for any celebration. Get free shipping and addressing!",
      keywords: 'dusty rose save the date, dusty rose save the date cards',
      canonical: `${STD_LINK}/dusty_rose`,
    },
    coral: {
      title_tag: 'Coral Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's coral save the dates. Dynamic, vibrant templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'coral save the date, coral save the date cards',
      canonical: `${STD_LINK}/coral`,
    },
    peach: {
      title_tag: 'Peach Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's peach save the dates. Warm, trendy templates perfect for any celebration. Get free shipping, addressing and envelopes!",
      keywords: 'peach save the date, peach save the date cards',
      canonical: `${STD_LINK}/peach`,
    },
    emerald_green: {
      title_tag: 'Emerald Green Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's emerald green save the dates. Rich, jewel tone templates perfect for any celebration. Free shipping and addressing!",
      keywords: 'emerald green save the date cards',
      canonical: `${STD_LINK}/emerald_green`,
    },
    teal: {
      title_tag: 'Teal Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's teal save the dates. Unique, elegant templates perfect for any celebration. Get free shipping and envelopes!",
      keywords: 'teal save the date, teal save the date cards',
      canonical: `${STD_LINK}/teal`,
    },
    black: {
      title_tag: 'Black Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's black save the dates. Elegant templates perfect for any celebration. Free shipping, guest addressing and envelopes!",
      keywords: 'black save the date, black save the date cards',
      canonical: `${STD_LINK}/black`,
    },
    blue: {
      title_tag: 'Blue Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's blue save the dates. Faithful templates perfect for any celebration. Free shipping, guest addressing and envelopes!",
      keywords: 'blue save the date, blue save the date cards',
      canonical: `${STD_LINK}/blue`,
    },
    brown: {
      title_tag: 'Brown Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's brown save the dates. Modern, rustic templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'brown save the date, brown save the date cards',
      canonical: `${STD_LINK}/brown`,
    },
    green: {
      title_tag: 'Green Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's green save the dates. Soft, earthy templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'green save the date, green save the date cards',
      canonical: `${STD_LINK}/green`,
    },
    grey: {
      title_tag: 'Grey Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's grey save the dates. Upscale, modern templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'grey save the date, grey save the date cards',
      canonical: `${STD_LINK}/grey`,
    },
    orange: {
      title_tag: 'Orange Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's orange save the dates. Bright, joyful templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'orange save the date, orange save the date cards',
      canonical: `${STD_LINK}/orange`,
    },
    pink: {
      title_tag: 'Pink Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's pink save the dates. Romantic, warm templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'pink save the date, pink save the date cards',
      canonical: `${STD_LINK}/pink`,
    },
    purple: {
      title_tag: 'Purple Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's purple save the dates. Lush, royal templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords:
        'purple save the date, purple save the date cards, purple wedding save the date cards',
      canonical: `${STD_LINK}/purple`,
    },
    red: {
      title_tag: 'Red Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's red save the dates. Bold, passionate templates perfect for any celebration. Get free shipping and envelopes!",
      keywords: 'red save the date, red save the date cards',
      canonical: `${STD_LINK}/red`,
    },
    white: {
      title_tag: 'White Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's white save the dates. Pure, delicate templates perfect for any celebration. Get free shipping and guest addressing!",
      keywords: 'white save the date, white save the date cards',
      canonical: `${STD_LINK}/white`,
    },
    yellow: {
      title_tag: 'Yellow Save the Date Card Templates - Zola',
      meta:
        "Set the tone for your big day with Zola's yellow save the dates. Bright, beautiful templates perfect for any celebration. Get free shipping, envelopes and more!",
      keywords: 'yellow save the date, yellow save the date cards',
      canonical: `${STD_LINK}/yellow`,
    },
  },
};

export const PARAM_CATEGORIES = [
  {
    urlKey: 'features',
    keys: ['has_foil', 'has_custom_photo', 'has_no_custom_photo', 'has_magnet'],
  },
  {
    urlKey: 'orientations',
    keys: ['is_portrait', 'is_landscape'],
  },
  {
    urlKey: 'receptionOnly',
    keys: ['is_vow_renewal'],
  },
  {
    urlKey: 'featuredArtists',
    keys: ['featured_artist'],
  },
  {
    urlKey: 'is_letterpress',
    keys: ['is_letterpress'],
  },
  {
    urlKey: 'color',
    keys: ['multiColor'],
  },
  {
    urlKey: 'sorts',
    keys: ['sorts'],
  },
];
